import { render, staticRenderFns } from "./addPossibleAnswer.vue?vue&type=template&id=3bcce828&scoped=true&"
import script from "./addPossibleAnswer.vue?vue&type=script&lang=js&"
export * from "./addPossibleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcce828",
  null
  
)

export default component.exports